<template>
  <v-container grid-list-xl>
    <v-dialog
      v-model="HDDdialog"
      max-width="320"
    >
      <v-card>
        <v-card-text>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            flat
            @click="HDDdialog = false"
          >
            Close
          </v-btn>

          <HDDpdfExport
            :disabled="selected.length == 0"
            :HDDs="currentLotAssets"
            :selected="selected"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout
      wrap
      align-center
    >
      <v-flex xs12>
        <v-breadcrumbs
          large
          :items="items"
          divider=">"
        ></v-breadcrumbs>
      </v-flex>
      <dymoPrintPreview
        v-on:Modalclose="close"
        v-if="Printdialog"
        v-bind:assets="selected"
      />
      <MagentoDetail
        v-on:mageModalclose="mageclose"
        v-bind:assetList="selected"
        v-if="magentoDialog"
      />
      <updateStatusDialog
        v-on:dialogclose="deleteDialog = false"
        :deleteDialog="deleteDialog"
        :inputData="selected"
      />

      <v-dialog
        v-model="overwritedialog"
        max-width="290"
      >
        <v-card>
          <v-card-text>Record with same id found, overwrite?</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              flat="flat"
              @click="overwritedialog = false"
            >Cancel</v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="overwritedialog = false,confirmRewrite()"
            >Overwrite</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-flex xs12>
        <v-toolbar>
          <v-flex sm2>
            <v-autocomplete
              :items="clientList"
              v-model="clientQuery"
              label="Customer"
              hide-details
              required
              v-on:change="onClientSelect()"
            ></v-autocomplete>

          </v-flex>
          <v-flex sm2>
            <v-autocomplete
              :disabled='!clientQuery'
              :items="lotList"
              v-model="lotnumberQuery"
              label="Lot"
              hide-details
              required
            ></v-autocomplete>

          </v-flex>
          <v-flex sm2>
            <v-autocomplete
              :disabled='!clientQuery'
              :items="locationList"
              v-model="locationQuery"
              label="Location"
              hide-details
              required
            ></v-autocomplete>

          </v-flex>
          <v-flex sm2>
            <v-autocomplete
              :items="brandList"
              v-model="makeQuery"
              label="Make"
              hide-details
              required
            ></v-autocomplete>

          </v-flex>
          <v-flex sm2>
            <v-autocomplete
              :items="modelList"
              v-model="modelQuery"
              label="Model"
              hide-details
            ></v-autocomplete>
          </v-flex>
          <v-flex sm4>
            <v-overflow-btn
              :items="cpuSetting"
              v-model="cpuQuery"
              label="Processor"
              hide-details
            ></v-overflow-btn>
          </v-flex>
          <v-flex sm2>
            <v-text-field
              prepend-icon="search"
              v-model="ramQuery"
              label="RAM(GB)"
              type="number"
              required
            ></v-text-field>
          </v-flex>

          <v-flex sm2>
            <v-text-field
              v-model="storageQuery"
              label="HDD(GB)"
              type="number"
              required
            ></v-text-field>
          </v-flex>

          <template v-slot:extension>
            <v-btn
              flat
              icon
              title='search'
              @click="search"
            >
              <v-icon>search</v-icon>
            </v-btn>
            <v-btn
              icon
              title='clear filter'
              @click="clear"
            >
              <v-icon>clear</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              title='upload json file'
              @click="uploadJSON()"
            >
              <v-icon>attachment</v-icon>
            </v-btn>
            <input
              type="file"
              style="display: none"
              ref="jsonFile"
              accept="application/json"
              @change="onFilePicked"
            >
            <v-btn
              :disabled="selected.length == 0"
              title='Generate HDD Report'
              @click="generateHDDReport"
              flat
              icon
            >
              <v-icon>camera_rear</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              title='download CSV'
              :disabled="selected.length == 0"
              @click="csvOBJ"
              flat
              icon
            >
              <v-icon>cloud_download</v-icon>
            </v-btn>
            <v-btn
              title='upload to magento'
              icon
              :disabled="selected.length == 0"
              @click.stop="magentoDialog = true"
              flat
            ><img
                width='26px'
                src='https://firebasestorage.googleapis.com/v0/b/tech-reuse.appspot.com/o/112651_development_435x512.png?alt=media&token=842aeaf9-f41d-4b86-a0d3-471952d2d437'
              /></v-btn>
            <v-btn
              :disabled="selected.length == 0"
              @click.stop="Printdialog = true"
              flat
              icon
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn
              title='update status'
              :disabled="selected.length == 0"
              @click.stop="deleteDialog = true"
              flat
              icon
            >
              <v-icon>delete</v-icon>
            </v-btn>
          </template>

        </v-toolbar>
      </v-flex>

      <v-flex xs12>
        <div
          class="hide-overflow"
          style="position: relative;"
        >

          <div
            id="scrolling"
            class="scroll-y"
            style="max-height: 600px;"
          >
            <v-container style="height: 1000px;">
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="dataTablesearch"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :rows-per-page-items="[50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                v-model="selected"
                select-all
                no-data-text
                no-results-text
                disable-initial-sort
                item-key="Discovery.AssetTag"
                :headers="headers"
                :items="assetsArr"
                :search="dataTablesearch"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td>
                    <v-checkbox
                      v-model="props.selected"
                      primary
                    ></v-checkbox>
                  </td>
                  <td
                    style="cursor : pointer "
                    @click.stop="goTo(props.item)"
                  >
                    <a>{{ props.item.Discovery.AssetTag }}</a>
                    <v-icon
                      title='HDD Wipe Report Available'
                      v-if='props.item.WipedHDDs'
                    >camera_rear</v-icon>
                  </td>
                  <td>{{ props.item.Time }}</td>
                  <td>{{ props.item.Discovery.SystemInfo.Make }}</td>
                  <td>{{ props.item.Discovery.SystemInfo.Model }}</td>
                  <td>{{ props.item.Discovery.CpuTitle }}</td>
                  <td>{{ props.item.Discovery.RamTitle }}</td>
                  <td>{{ props.item.Discovery.HddTitle }}</td>

                  <td>{{ props.item.Discovery.SystemInfo.Serial }}</td>
                  <td>{{ props.item.Discovery.Sku }}</td>
                </template>
                <template v-slot:footer>
                  <td :colspan="4">
                    <strong>{{selected.length}} items selected</strong>
                  </td>

                </template>
              </v-data-table>

            </v-container>
          </div>
        </div>

      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
import HDDpdfExport from "../components/HDDpdfExport"
import dymoPrintPreview from "../components/PrintPreview.vue";
import MagentoDetail from "../components/MagentoDialog.vue";
import updateStatusDialog from "../components/UpdateStatusDialog"
const fb = require("../firebaseConfig.js");
const { Parser } = require("json2csv");
import { FireSQL } from 'firesql';
import { mapFields } from 'vuex-map-fields';
export default {
  name: "assets",
  components: {
    updateStatusDialog,
    dymoPrintPreview,
    MagentoDetail,
    HDDpdfExport
  },
  computed: {
    ...mapFields([
      'snackBarcolor',
      'snackBarMessage',
      'snackBar'
    ]),
  },
  data () {
    return {
      HDDdialog: false,
      currentLotAssets: [],
      items: [
        {
          text: 'Home',
          disabled: false,
          to: 'home'
        },
        {
          text: 'Inventory',
          disabled: false,
          to: 'inventory'
        },
        {
          text: 'Computers',
          disabled: true,
          to: 'computerassets'
        }
      ],
      dataTablesearch: "",
      magentoDialog: false,
      Printdialog: false,
      uploadedjson: null,
      overwritedialog: false,
      selectedAsset: null,
      deleteDialog: false,
      brandList: [],
      modelList: [],
      selected: [],
      title: "Search Asset",
      cpuSetting: [],
      lotList: [],
      clientList: [],
      locationList: [],
      makeQuery: "",
      modelQuery: "",
      locationQuery: "",
      clientQuery: "",
      lotnumberQuery: "",
      storageQuery: "",
      cpuQuery: "",
      ramQuery: "",
      assetsArr: [],
      valid: true,
      headers: [
        { text: "Asset Tag", value: "Discovery.AssetTag" },
        { text: "Created Time", value: "Time" },
        { text: "Make", value: "Discovery.SystemInfo.Make" },
        { text: "Model", value: "Discovery.SystemInfo.Model" },
        { text: "CPU", value: "Discovery.CpuTitle", },
        { text: "RAM", value: "Discovery.RamTitle", },
        { text: "HDD", value: "Discovery.HddTitle", },
        { text: "Serial", value: "Discovery.SystemInfo.Serial" },
        { text: "SKU", value: "Discovery.Sku" }
        // { text: 'Actions', value:'' ,sortable: false }
      ]
    };
  },
  methods: {
    generateHDDReport () {
      this.currentLotAssets = []
      this.selected.forEach(item => {
        fb.HDDWIPECollection.where("AssetTag", "==", item.Discovery.AssetTag).get().then(snapshot => {
          snapshot.forEach(doc => {
            this.currentLotAssets.push(doc.data());
          });
        })
      })
      this.HDDdialog = true
    },
    initData () {
      fb.CustomersCollections.get().then(docs => {
        docs.docs.forEach(element => {
          this.clientList.push(element.id)
        });
      })
      fb.IndexCollections.doc("pcIndexs")
        .onSnapshot(docs => {
          this.brandList = docs.data().Brand
          this.modelList = docs.data().Model
        });
      fb.SettingsCollections.doc("searchDropDownValue").onSnapshot(doc => {
        this.cpuSetting = doc.data().cpuNameSettings;
        fb.AssetsCollections.orderBy("Time", "desc")
          .onSnapshot(querySnapshot => {
            this.assetsArr = [];
            querySnapshot.forEach(doc => {
              if (
                doc.data().Discovery.Status === "ready" &&
                doc.data().AssetType === "computer"
              ) {
                this.assetsArr.push(doc.data());
              }
            });
            this.title =
              "Search Asset (Showing most recent 50 records order by time)";
          });
      });
    },
    mageclose () {
      this.magentoDialog = false;
    },
    close () {
      this.Printdialog = false;
    },
    onClientSelect () {
      this.locationList = [],
        this.lotList = []
      fb.CustomersCollections.doc(this.clientQuery)
        .get()
        .then(doc => {
          this.locationList = doc.data().locations;
        });
      fb.LotsCollections.where("client", "==", this.clientQuery).get()
        .then(docs => {
          docs.forEach(items => {
            this.lotList.push(items.data().lotNumber);
          })
        });
    },
    uploadJSON () {
      //triger file upload function by triggering the click on the hidden input
      this.$refs.jsonFile.value = "";
      this.$refs.jsonFile.click();
    },
    confirmRewrite () {
      fb.AssetsCollections.doc(this.uploadedjson.Discovery.AssetTag).set(
        this.uploadedjson
      );
    },
    onFilePicked (e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf(".") <= 0) {
          return;
        }
        const reader = new FileReader();
        reader.readAsText(files[0]);
        reader.onload = event => {
          var json = event.target.result;
          try {
            this.uploadedjson = JSON.parse(json);
            fb.AssetsCollections.doc(this.uploadedjson.Discovery.AssetTag)
              .get()
              .then(item => {
                if (item.exists) {
                  this.overwritedialog = true;
                } else {
                  fb.AssetsCollections.doc(this.uploadedjson.Discovery.AssetTag).set(
                    this.uploadedjson
                  );
                }
              });
          } catch (e) {
            this.snackBarcolor = "error";
            this.snackBarMessage = "failed to read JSON file.";
            this.snackBar = true;
            return "error";
          }
        };
      }
    },
    deleteItem (input) {
      //remove asset from location if any
      fb.LocationsCollections.where(
        "assets",
        "array-contains",
        input.Discovery.AssetTag
      )
        .get()
        .then(items => {
          if (items.empty !== true) {
            items.forEach(item => {
              var docID = item.id;
              var collection = item.data().assets;
              collection = collection.filter(target => {
                return target !== input.Discovery.AssetTag;
              });
              fb.LocationsCollections.doc(docID).update({
                assets: collection
              });
            });
          }
        });
      //mark asset as recycled
      fb.AssetsCollections.doc(input.Discovery.AssetTag).update({
        ["Discovery.Status"]: "recycled"
      });
    },
    goTo (item) {
      this.$router.push("/assets/" + item.Discovery.AssetTag);
    },
    csvOBJ () {
      var json = this.selected.map(x => x);
      const json2csvParser = new Parser({ flatten: true });
      const csv = json2csvParser.parse(json);
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += csv;
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
      return json;
    },
    clear () {
      this.cpuQuery = "";
      this.ramQuery = "";
      this.storageQuery = "";
      this.clientQuery = "";
      this.lotnumberQuery = "";
      this.makeQuery = "";
      this.modelQuery = "";
      this.locationQuery = "";
      this.lotnumberQuery = ""
      this.initData();
    },
    search () {
      var sql = ""
      var searchtype = ""
      //if client is not null, we filter the hardware result
      if (this.clientQuery !== "") {
        sql = 'SELECT * FROM Assets where client = "' + this.clientQuery + '" '
      }
      //else we run query by hardware
      else {
        if (this.cpuQuery !== "") {
          sql = 'SELECT * FROM Assets where `Discovery.CpuTitle` like "' + this.cpuQuery + '%" AND `Discovery.Status` = "ready"'
          searchtype = 'cpu'
        }
        else if (this.makeQuery !== "") {
          sql = 'SELECT * FROM Assets where `Discovery.SystemInfo.Make` like "' + this.makeQuery + '%" AND `Discovery.Status` = "ready"'
          searchtype = 'make'
        }
        else if (this.modelQuery !== "") {
          sql = 'SELECT * FROM Assets where `Discovery.SystemInfo.Model` like "' + this.modelQuery + '%" AND `Discovery.Status` = "ready"'
          searchtype = 'model'
        }
      }
      this.query(sql, searchtype, () => {
        if (this.lotnumberQuery !== "") {
          var tempArr = []
          const fireSQL = new FireSQL(fb.db)
          fireSQL.query('SELECT Assets FROM Lots where lotNumber = ' + this.lotnumberQuery + '').then(documents => {
            documents.forEach(doc => {
              doc = Object.values(doc)
              doc[0].forEach(subdoc => {
                this.assetsArr.filter(item => {
                  if (item.Discovery.AssetTag == subdoc) {
                    tempArr.push(item)
                    return false
                  }
                })
              })
            })
            this.assetsArr = tempArr
          })
        }
        if (this.locationQuery !== "") {
          var temp = []
          this.assetsArr.filter(item => {
            if (item.Discovery.Location == this.locationQuery) { temp.push(item) } return true
          })
          this.assetsArr = temp
        }
      })
    },
    query (queryText, searchtype, callback) {
      this.assetsArr = [];
      const fireSQL = new FireSQL(fb.db)
      fireSQL.query(queryText).then(documents => {
        documents.forEach(doc => {
          this.assetsArr.push(doc);
        })
        if (this.ramQuery !== "") {
          this.assetsArr = this.assetsArr.filter(
            item => item.Discovery.RamTitle == this.ramQuery
          );
        }
        if (this.storageQuery !== "") {
          this.assetsArr = this.assetsArr.filter(
            item => item.Discovery.HddTitle == this.storageQuery
          );
        }
        if (this.makeQuery !== "" && searchtype !== "make") {
          this.assetsArr = this.assetsArr.filter(
            item => item.Discovery.SystemInfo.Make === this.makeQuery
          );
        }
        if (this.modelQuery !== "" && searchtype !== "model") {
          this.assetsArr = this.assetsArr.filter(
            item => item.Discovery.SystemInfo.Model === this.modelQuery
          )
          if (this.cpuQuery !== "" && searchtype !== "cpu") {
            this.assetsArr = this.assetsArr.filter(
              item => item.Discovery.CpuTitle === this.cpuQuery
            )
          }
        }
        callback()      })
    }
  },
  mounted () {
    this.initData()
  }
};
</script>